import { Pressable, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import React from 'react';

const pressableStyles = xcss({
  color: 'color.text.subtle',
  backgroundColor: 'color.background.neutral.subtle',
  fontWeight: token('font.weight.medium'),

  ':hover': {
    textDecoration: 'underline',
  },
  ':active': {
    color: 'color.text',
  },
});

const disabledStyles = xcss({
  cursor: 'default',
  color: 'color.text.disabled',
  ':hover': {
    textDecoration: 'none',
  },
  ':active': {
    color: 'color.text.disabled',
  },
});

const TextButton = ({
  text,
  onClick,
  isDisabled = false,
}: {
  text: string;
  onClick: () => void;
  isDisabled?: boolean;
}) => {
  return (
    // @ts-ignore ignore broken atlaskit props
    <Pressable
      isDisabled={isDisabled}
      onClick={onClick}
      xcss={[pressableStyles, isDisabled && disabledStyles]}
    >
      {text}
    </Pressable>
  );
};

export default TextButton;
